var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', [_c('b-card-actions', {
    attrs: {
      "title": "Filters",
      "action-collapse": ""
    }
  }, [_c('div', [_c('b-row', {
    staticClass: "mb-1"
  }, [_c('b-col', {
    attrs: {
      "md": "8",
      "lg": "8",
      "xs": "12"
    }
  }, [_c('b-form-input', {
    staticClass: "d-inline-block mr-sm-1 mb-1 mb-sm-0 custom-font",
    attrs: {
      "placeholder": "Search By Expense Title",
      "type": "text"
    },
    on: {
      "keyup": _vm.onSearch
    },
    model: {
      value: _vm.searchTerm,
      callback: function callback($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "8",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Enter Due Date Range",
      "config": {
        mode: 'range'
      }
    },
    on: {
      "input": _vm.loadItems
    },
    model: {
      value: _vm.filterRangeDate,
      callback: function callback($$v) {
        _vm.filterRangeDate = $$v;
      },
      expression: "filterRangeDate"
    }
  })], 1)], 1)], 1), _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mr-sm-1 mb-1 mb-sm-0 custom-font",
    attrs: {
      "options": _vm.filterAccountOptionId,
      "reduce": function reduce(item) {
        return item.id;
      },
      "label": "name",
      "placeholder": "By Account"
    },
    on: {
      "input": _vm.filterByAccount
    },
    model: {
      value: _vm.filterAccountId,
      callback: function callback($$v) {
        _vm.filterAccountId = $$v;
      },
      expression: "filterAccountId"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mr-sm-1 mb-1 mb-sm-0 custom-font",
    attrs: {
      "options": _vm.filterDepartmentOptionId,
      "reduce": function reduce(item) {
        return item.id;
      },
      "label": "name",
      "placeholder": "By Department"
    },
    on: {
      "input": _vm.filterByDepartment
    },
    model: {
      value: _vm.filterDepartmentId,
      callback: function callback($$v) {
        _vm.filterDepartmentId = $$v;
      },
      expression: "filterDepartmentId"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mr-sm-1 mb-1 mb-sm-0 custom-font",
    attrs: {
      "options": _vm.expenseStatusTypeConstants,
      "reduce": function reduce(item) {
        return item.value;
      },
      "label": "name",
      "placeholder": "By Expense Status"
    },
    on: {
      "input": _vm.filterByStatus
    },
    model: {
      value: _vm.filterStatus,
      callback: function callback($$v) {
        _vm.filterStatus = $$v;
      },
      expression: "filterStatus"
    }
  })], 1)], 1)], 1)])], 1), _c('div', [_c('b-card', [_c('div', [_c('div', {
    staticClass: "custom-search d-flex align-items-center justify-content-end"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-sm-row align-items-center mb-1 justify-content-around"
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 mr-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.exportHistory
    }
  }, [_vm._v(" Export ")]), _vm.$permissionAbility(_vm.EXPENSE_CREATE, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 mr-1",
    attrs: {
      "variant": "gradient-primary"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v(" Create ")])] : _vm._e()], 2)]), _c('vue-good-table', {
    attrs: {
      "styleClass": "vgt-table table-custom-style striped",
      "mode": "remote",
      "totalRows": _vm.totalRecords,
      "isLoading": _vm.isLoading,
      "rows": _vm.rows,
      "sort-options": {
        enabled: false,
        multipleColumns: true,
        initialSortBy: [{
          field: 'id',
          type: 'desc'
        }]
      },
      "columns": _vm.columns,
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "on-per-page-change": _vm.onPerPageChange,
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$row, _props$row3, _props$row4, _props$row5, _props$row5$departmen, _props$row5$departmen2, _props$row6, _props$row7, _props$row7$project, _props$row7$project$d, _props$row7$project$d2, _props$row7$project$d3, _props$row8, _props$row9, _props$column, _props$row11, _props$row11$account, _props$row11$account$, _props$row12, _props$row12$account, _props$row12$account$, _props$row13, _props$row13$account, _props$row13$account$, _props$row14, _props$row14$account, _props$row14$account$, _props$row15, _props$row15$account, _props$row15$account$, _props$row16, _props$row16$account, _props$row16$account$, _props$row17, _props$row17$account, _props$row17$account$, _props$row18, _props$row18$account, _props$row18$account$, _props$row19, _props$row20, _props$column2, _props$row21, _props$row22, _props$row23, _props$row24, _props$row25, _props$row26, _props$row26$expenseT, _props$row26$expenseT2, _props$row27, _props$row27$account, _props$row27$account$, _props$row28, _props$row29, _props$row30, _props$row31, _props$row32, _props$row33;
        return [props.column.field === 'format_title' ? _c('span', [(_props$row = props.row) !== null && _props$row !== void 0 && _props$row.title ? [_c('div', {
          staticClass: "cell-with-description"
        }, [_vm._v(" Title: "), _c('b-link', {
          attrs: {
            "href": _vm.getPageUrl(props.row.id)
          },
          on: {
            "click": function click($event) {
              var _props$row2;
              return _vm.onShowPage(props === null || props === void 0 ? void 0 : (_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : _props$row2.id);
            }
          }
        }, [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row3 = props.row) === null || _props$row3 === void 0 ? void 0 : _props$row3.title) + " ")])], 1)] : _vm._e(), (_props$row4 = props.row) !== null && _props$row4 !== void 0 && _props$row4.department ? [_c('div', {
          staticClass: "cell-with-description"
        }, [_vm._v(" Dept: "), _c('b', [_vm._v(_vm._s((_props$row5 = props.row) === null || _props$row5 === void 0 ? void 0 : (_props$row5$departmen = _props$row5.department) === null || _props$row5$departmen === void 0 ? void 0 : (_props$row5$departmen2 = _props$row5$departmen.data) === null || _props$row5$departmen2 === void 0 ? void 0 : _props$row5$departmen2.name))])])] : _vm._e(), (_props$row6 = props.row) !== null && _props$row6 !== void 0 && _props$row6.project ? [_c('div', {
          staticClass: "cell-with-description"
        }, [_vm._v(" Project: "), _c('b', [_vm._v(_vm._s((_props$row7 = props.row) === null || _props$row7 === void 0 ? void 0 : (_props$row7$project = _props$row7.project) === null || _props$row7$project === void 0 ? void 0 : (_props$row7$project$d = _props$row7$project.data) === null || _props$row7$project$d === void 0 ? void 0 : (_props$row7$project$d2 = _props$row7$project$d.lead) === null || _props$row7$project$d2 === void 0 ? void 0 : (_props$row7$project$d3 = _props$row7$project$d2.data) === null || _props$row7$project$d3 === void 0 ? void 0 : _props$row7$project$d3.title))])])] : _vm._e(), props !== null && props !== void 0 && (_props$row8 = props.row) !== null && _props$row8 !== void 0 && _props$row8.file ? [_c('div', {
          staticClass: "cell-with-description"
        }, [_c('b-link', {
          attrs: {
            "href": props === null || props === void 0 ? void 0 : (_props$row9 = props.row) === null || _props$row9 === void 0 ? void 0 : _props$row9.file,
            "target": "_blank"
          }
        }, [_vm._v(" Download / View Attachment ")])], 1)] : _vm._e(), [_c('b-button', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple.400",
            value: 'rgba(113, 102, 240, 0.15)',
            expression: "'rgba(113, 102, 240, 0.15)'",
            modifiers: {
              "400": true
            }
          }],
          staticClass: "btn-sm cell-with-description",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              var _props$row10;
              return _vm.showDescriptionModal((_props$row10 = props.row) === null || _props$row10 === void 0 ? void 0 : _props$row10.remarks);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "InfoIcon"
          }
        })], 1)]], 2) : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column = props.column) === null || _props$column === void 0 ? void 0 : _props$column.field) === 'format_account_info' ? [_c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row11 = props.row) === null || _props$row11 === void 0 ? void 0 : (_props$row11$account = _props$row11.account) === null || _props$row11$account === void 0 ? void 0 : (_props$row11$account$ = _props$row11$account.data) === null || _props$row11$account$ === void 0 ? void 0 : _props$row11$account$.name))]), _c('div', {
          staticClass: "cell-with-description"
        }, [props !== null && props !== void 0 && (_props$row12 = props.row) !== null && _props$row12 !== void 0 && (_props$row12$account = _props$row12.account) !== null && _props$row12$account !== void 0 && (_props$row12$account$ = _props$row12$account.data) !== null && _props$row12$account$ !== void 0 && _props$row12$account$.email ? _c('div', [_c('span', [_vm._v(" Email: "), _c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row13 = props.row) === null || _props$row13 === void 0 ? void 0 : (_props$row13$account = _props$row13.account) === null || _props$row13$account === void 0 ? void 0 : (_props$row13$account$ = _props$row13$account.data) === null || _props$row13$account$ === void 0 ? void 0 : _props$row13$account$.email))])])]) : _vm._e(), props !== null && props !== void 0 && (_props$row14 = props.row) !== null && _props$row14 !== void 0 && (_props$row14$account = _props$row14.account) !== null && _props$row14$account !== void 0 && (_props$row14$account$ = _props$row14$account.data) !== null && _props$row14$account$ !== void 0 && _props$row14$account$.account_number ? _c('div', [_c('span', [_vm._v(" Acc No: "), _c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row15 = props.row) === null || _props$row15 === void 0 ? void 0 : (_props$row15$account = _props$row15.account) === null || _props$row15$account === void 0 ? void 0 : (_props$row15$account$ = _props$row15$account.data) === null || _props$row15$account$ === void 0 ? void 0 : _props$row15$account$.account_number))])])]) : _vm._e(), props !== null && props !== void 0 && (_props$row16 = props.row) !== null && _props$row16 !== void 0 && (_props$row16$account = _props$row16.account) !== null && _props$row16$account !== void 0 && (_props$row16$account$ = _props$row16$account.data) !== null && _props$row16$account$ !== void 0 && _props$row16$account$.account_holder_name ? _c('div', [_c('span', [_vm._v(" Holder Name: "), _c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row17 = props.row) === null || _props$row17 === void 0 ? void 0 : (_props$row17$account = _props$row17.account) === null || _props$row17$account === void 0 ? void 0 : (_props$row17$account$ = _props$row17$account.data) === null || _props$row17$account$ === void 0 ? void 0 : _props$row17$account$.account_holder_name))])])]) : _vm._e(), _c('div', [_c('span', [_vm._v(" Currency: "), _c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row18 = props.row) === null || _props$row18 === void 0 ? void 0 : (_props$row18$account = _props$row18.account) === null || _props$row18$account === void 0 ? void 0 : (_props$row18$account$ = _props$row18$account.data) === null || _props$row18$account$ === void 0 ? void 0 : _props$row18$account$.currency))])])])])] : _vm._e(), props.column.field === 'payed' ? _c('span', [_c('b-badge', {
          attrs: {
            "pill": "",
            "variant": _vm.statusVariant((_props$row19 = props.row) === null || _props$row19 === void 0 ? void 0 : _props$row19.is_payed)
          }
        }, [_vm._v(" " + _vm._s((_props$row20 = props.row) !== null && _props$row20 !== void 0 && _props$row20.is_payed ? "Paid" : "Due") + " ")])], 1) : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column2 = props.column) === null || _props$column2 === void 0 ? void 0 : _props$column2.field) === 'format_invoice' ? [props !== null && props !== void 0 && (_props$row21 = props.row) !== null && _props$row21 !== void 0 && _props$row21.payslip_created_date ? [props !== null && props !== void 0 && (_props$row22 = props.row) !== null && _props$row22 !== void 0 && _props$row22.payslip_no ? [_c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-primary"
          }
        }, [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row23 = props.row) === null || _props$row23 === void 0 ? void 0 : _props$row23.payslip_no))])] : _vm._e(), props !== null && props !== void 0 && (_props$row24 = props.row) !== null && _props$row24 !== void 0 && _props$row24.payslip_created_date ? [_c('div', {
          staticClass: "table-cell-margin"
        }, [_c('b', [_vm._v("Created On: ")]), _c('span', [_vm._v(" " + _vm._s(_vm.formatFnTableCreatedDate(props === null || props === void 0 ? void 0 : (_props$row25 = props.row) === null || _props$row25 === void 0 ? void 0 : _props$row25.payslip_created_date)))])])] : _vm._e()] : _vm._e()] : _vm._e(), props.column.field === 'expense_type' ? _c('span', [_vm._v(" " + _vm._s((_props$row26 = props.row) === null || _props$row26 === void 0 ? void 0 : (_props$row26$expenseT = _props$row26.expenseType) === null || _props$row26$expenseT === void 0 ? void 0 : (_props$row26$expenseT2 = _props$row26$expenseT.data) === null || _props$row26$expenseT2 === void 0 ? void 0 : _props$row26$expenseT2.name) + " ")]) : _vm._e(), props.column.field === 'account_name' ? _c('span', [_vm._v(" " + _vm._s((_props$row27 = props.row) === null || _props$row27 === void 0 ? void 0 : (_props$row27$account = _props$row27.account) === null || _props$row27$account === void 0 ? void 0 : (_props$row27$account$ = _props$row27$account.data) === null || _props$row27$account$ === void 0 ? void 0 : _props$row27$account$.name) + " ")]) : _vm._e(), props.column.field === 'format_amount' ? _c('span', [_c('FormatCurrency', {
          attrs: {
            "amount": (_props$row28 = props.row) === null || _props$row28 === void 0 ? void 0 : _props$row28.amount,
            "currency": (_props$row29 = props.row) === null || _props$row29 === void 0 ? void 0 : _props$row29.currency
          }
        })], 1) : _vm._e(), props.column.field === 'format_currency' ? _c('span', [_c('FormatCurrency', {
          attrs: {
            "type": 'currency',
            "amount": (_props$row30 = props.row) === null || _props$row30 === void 0 ? void 0 : _props$row30.amount,
            "currency": (_props$row31 = props.row) === null || _props$row31 === void 0 ? void 0 : _props$row31.currency
          }
        })], 1) : _vm._e(), props.column.field === 'formate_file' ? [props !== null && props !== void 0 && (_props$row32 = props.row) !== null && _props$row32 !== void 0 && _props$row32.file ? [_c('b-link', {
          attrs: {
            "href": props === null || props === void 0 ? void 0 : (_props$row33 = props.row) === null || _props$row33 === void 0 ? void 0 : _props$row33.file,
            "target": "_blank"
          }
        }, [_vm._v(" Download / View ")])] : [_c('span', [_vm._v("No Files To Download")])]] : _vm._e(), props.column.field === 'action' ? _c('span', [_c('span', [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "toggle-class": "text-decoration-none",
            "no-caret": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "text-body align-middle mr-25",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_vm.$permissionAbility(_vm.PAYSLIP_ACCESS, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              var _props$row34;
              return _vm.onShowPage(props === null || props === void 0 ? void 0 : (_props$row34 = props.row) === null || _props$row34 === void 0 ? void 0 : _props$row34.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "FileTextIcon"
          }
        }), _c('span', [_vm._v("Show Payslip")])], 1)] : _vm._e(), _vm.$permissionAbility(_vm.EXPENSE_EDIT, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.onShow(props === null || props === void 0 ? void 0 : props.row);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "Edit2Icon"
          }
        }), _c('span', [_vm._v("Edit")])], 1)] : _vm._e(), _vm.$permissionAbility(_vm.EXPENSE_DELETE, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.onDelete(props.row.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "TrashIcon"
          }
        }), _c('span', [_vm._v("Delete")])], 1)] : _vm._e()], 2)], 1)]) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-expense-form",
      "centered": "",
      "title": _vm.modelType == 'editModel' ? 'Edit Expense' : 'Add Expense',
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenModal
    }
  }, [_c('validation-observer', {
    ref: "expansesValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.validationForm($event);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Department *",
      "label-for": "department-id"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "department_id",
      "vid": "department_id",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('v-select', {
          attrs: {
            "id": "department-id",
            "placeholder": "Choose a Department",
            "options": _vm.departmentIdOption,
            "reduce": function reduce(option) {
              return option.id;
            },
            "label": "name"
          },
          on: {
            "input": _vm.onChangeDepartment
          },
          model: {
            value: _vm.departmentId,
            callback: function callback($$v) {
              _vm.departmentId = $$v;
            },
            expression: "departmentId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Project",
      "label-for": "project"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "project",
      "vid": "project_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('v-select', {
          attrs: {
            "id": "project",
            "placeholder": "Choose a Project ",
            "options": _vm.projectIdOption,
            "reduce": function reduce(option) {
              return option.id;
            },
            "label": "name"
          },
          on: {
            "input": _vm.onChangeProject
          },
          model: {
            value: _vm.projectId,
            callback: function callback($$v) {
              _vm.projectId = $$v;
            },
            expression: "projectId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Account *",
      "label-for": "account"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "account",
      "vid": "account",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('v-select', {
          attrs: {
            "id": "account",
            "placeholder": "Choose a Account",
            "options": _vm.accountsOption,
            "reduce": function reduce(option) {
              return option.id;
            },
            "label": "name"
          },
          model: {
            value: _vm.selectAccountId,
            callback: function callback($$v) {
              _vm.selectAccountId = $$v;
            },
            expression: "selectAccountId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Title *",
      "label-for": "title"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "title",
      "vid": "title",
      "rules": "required|max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "title",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Expense Title"
          },
          model: {
            value: _vm.title,
            callback: function callback($$v) {
              _vm.title = $$v;
            },
            expression: "title"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Amount *",
      "label-for": "amount"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "amount",
      "vid": "amount",
      "rules": "required|integer"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var errors = _ref5.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "amount",
            "type": "number",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Expense Amount",
            "rules": "required"
          },
          model: {
            value: _vm.amount,
            callback: function callback($$v) {
              _vm.amount = $$v;
            },
            expression: "amount"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.modelType != 'editModel' ? [_c('b-form-checkbox', {
    staticClass: "custom-control-primary mr-2 mb-1",
    model: {
      value: _vm.isInstantPay,
      callback: function callback($$v) {
        _vm.isInstantPay = $$v;
      },
      expression: "isInstantPay"
    }
  }, [_vm._v(" Instant Pay ")])] : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": _vm.modelType == 'editModel' ? 'Date *' : _vm.isInstantPay ? 'Date' : 'Date *',
      "label-for": "date"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "date",
      "vid": "date",
      "rules": _vm.modelType == 'editModel' ? 'required' : _vm.isInstantPay ? '' : 'required'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var errors = _ref6.errors;
        return [_c('b-form-datepicker', {
          attrs: {
            "id": "date",
            "state": errors.length > 0 ? false : null,
            "locale": "en-US",
            "reset-button": "",
            "disabled": _vm.modelType == 'editModel' ? false : _vm.isInstantPay
          },
          on: {
            "context": _vm.onContextStartDate
          },
          model: {
            value: _vm.date,
            callback: function callback($$v) {
              _vm.date = $$v;
            },
            expression: "date"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Attach File (Ext allowed : jpg,jpeg,png,pdf,csv,xlsx,txt,docx)",
      "label-for": "file"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "file",
      "rules": "size:2048|ext:jpg,jpeg,png,pdf,csv,xlsx,txt,docx",
      "vid": "file"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var errors = _ref7.errors;
        return [_c('b-form-file', {
          attrs: {
            "id": "file",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Choose a file or drop it here...",
            "drop-placeholder": "Drop file here..."
          },
          model: {
            value: _vm.file,
            callback: function callback($$v) {
              _vm.file = $$v;
            },
            expression: "file"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Remarks *",
      "label-for": "remarks"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "remarks",
      "vid": "remarks",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref8) {
        var errors = _ref8.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "remarks",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Remarks",
            "rows": "3"
          },
          model: {
            value: _vm.remarks,
            callback: function callback($$v) {
              _vm.remarks = $$v;
            },
            expression: "remarks"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.isTypeFormSubmitLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "description-modal",
      "centered": "",
      "title": "Remarks",
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenDescriptionModal
    }
  }, [_c('b-card-text', [_vm._v(" " + _vm._s(_vm.modalDescription) + " ")])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }